<template src="./header.html"></template>

<script>
export default {
    name: 'AppHeader',
    data() {
        return {
            currentDateTime: new Date(),
            username: '',
            loading: false
        }
    },
    async mounted() {
        var loginCred = localStorage.getItem('login');
        this.username = loginCred ? atob(loginCred.split(" ")[1]).split(":")[0] : 'Undefined';
        setInterval(() => {
            this.currentDateTime = new Date()
        }, 1000)
    },
    methods: {
        logout() {
            this.loading = true;
            setTimeout(() => {
                this.loading = false;
                localStorage.removeItem('login');
                localStorage.removeItem('token');
                this.$router.push('/login');
            }, 2000);
        }
    }
}
</script>
<style scoped></style>